import http from './http'

/**
 * List all saved payment methods for the authenticated user.
 * @returns {Promise<Array<{ id: string, type: string, label: string, isDefault: boolean }>>}
 */
export function listPaymentMethods () {
  return http.get('/payment-methods').then(function (res) {
    return res.data
  })
}

/**
 * Save an M-Pesa number as a payment method.
 * The first saved method becomes the default automatically.
 * Phone numbers are normalised server-side (07xx → +2547xx).
 * @param {{ label: string, phoneNumber: string }} payload
 * @returns {Promise<{ id: string, type: string, label: string, isDefault: boolean }>}
 */
export function addPaymentMethod (payload) {
  return http.post('/payment-methods', payload).then(function (res) {
    return res.data
  })
}

/**
 * Set a payment method as the default, clearing the flag from all others.
 * @param {string} id
 * @returns {Promise<{ isDefault: boolean }>}
 */
export function setDefaultPaymentMethod (id) {
  return http.patch('/payment-methods/' + id + '/default').then(function (res) {
    return res.data
  })
}

/**
 * Delete a payment method.
 * If it was the default, the next oldest method is promoted automatically.
 * Returns HTTP 204 with no body.
 * @param {string} id
 */
export function deletePaymentMethod (id) {
  return http.delete('/payment-methods/' + id).then(function (res) {
    return res.data
  })
}
